exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FullWidthImageViewer-155ebe3a{width:100%;overflow:hidden;position:relative}.FullWidthImageViewer-155ebe3a img{left:0;position:absolute;width:100%}\n", ""]);

// Exports
exports.locals = {
	"FullWidthImageViewer": "FullWidthImageViewer-155ebe3a"
};